import { render } from "./Tracking.vue?vue&type=template&id=6db5bca2&scoped=true"
import script from "./Tracking.vue?vue&type=script&lang=js"
export * from "./Tracking.vue?vue&type=script&lang=js"

import "./Tracking.vue?vue&type=style&index=0&id=6db5bca2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\hapiick-tracking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db5bca2"]])

export default __exports__